import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGetAllByGroup } from '../../services';

export const fetchSliderGetAllByGroup = createAsyncThunk(
    'sliderGetAllByGroup/fetchSliderGetAllByGroup',
    async ({ id }) => {
        const response = await SliderGetAllByGroup(id)
        return response.result
    }
);

const sliderGetAllByGroupSlice = createSlice({
    name: 'sliderGetAllByGroup',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGetAllByGroup.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGetAllByGroup.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGetAllByGroup.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGetAllByGroupSlice.reducer;
